import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

const PageHeader = ({
  title,
  subtitle,
  icon,
  backgroundIcon = null,
  showEmblem = true,
}) => {
  return (
    <div className="bg-deep-red text-white p-3 md:p-6 mb-4 shadow-lg rounded-lg relative overflow-hidden">
      {/* Background pattern with emblem */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        {backgroundIcon && (
          <div className="absolute -right-8 -top-8 md:-right-12 md:-top-12 opacity-10 rotate-12">
            <FontAwesomeIcon
              icon={backgroundIcon}
              className="text-white text-[80px] md:text-[140px]"
            />
          </div>
        )}
        <div className="absolute bottom-0 left-0 w-full h-2 md:h-4 bg-gradient-to-r from-white/10 to-white/0"></div>
      </div>

      {/* Content */}
      <div className="flex items-center relative z-10">
        <div className="bg-white rounded-full h-12 w-12 md:h-16 md:w-16 flex items-center justify-center mr-3 md:mr-4 shadow-md border-2 border-white/30 flex-shrink-0">
          <FontAwesomeIcon
            icon={icon}
            className="text-deep-red text-lg md:text-2xl"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h1 className="text-lg md:text-2xl lg:text-3xl font-extrabold tracking-tight leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-white/80 text-xs md:text-sm lg:text-base mt-0.5 md:mt-1 line-clamp-2">
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* DayShift Emblem */}
      {showEmblem && (
        <div className="absolute bottom-1.5 right-1.5 md:bottom-2 md:right-2 z-10 w-8 h-8 md:w-12 md:h-12">
          <img
            src="/emblem-gold.png"
            alt="DayShift Emblem"
            className="w-full h-full object-contain filter brightness-0 invert"
          />
        </div>
      )}
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.object.isRequired,
  backgroundIcon: PropTypes.object,
  showEmblem: PropTypes.bool,
};

export default PageHeader;
